"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatShortNumber = exports.formatAndNormalizeToken = exports.formatAndNormalize = exports.formatBigNumber = exports.denormalizeValue = exports.normalizeValue = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const SHORT_NUMBERS = [
    { decimals: 0, symbol: "" },
    { decimals: 3, symbol: "K" },
    { decimals: 6, symbol: "M" },
    { decimals: 9, symbol: "B" },
];
const normalizeValue = (value = 0, decimals, mathOps) => {
    let number = new bignumber_js_1.default(value || 0).div(`1e${decimals || 0}`);
    if (mathOps) {
        number = mathOps(number);
    }
    return number;
};
exports.normalizeValue = normalizeValue;
const denormalizeValue = (value = 0, decimals, mathOps) => (0, exports.normalizeValue)(value, decimals && "-" + decimals.toString(), mathOps);
exports.denormalizeValue = denormalizeValue;
const formatBigNumber = (value, config = [0], defaultValue = 0) => {
    let inputValue = new bignumber_js_1.default(value);
    if (inputValue.isNaN()) {
        inputValue = new bignumber_js_1.default(defaultValue);
    }
    return inputValue.toFormat(...config);
};
exports.formatBigNumber = formatBigNumber;
const formatAndNormalize = (...args) => (0, exports.formatBigNumber)((0, exports.normalizeValue)(...args));
exports.formatAndNormalize = formatAndNormalize;
const formatAndNormalizeToken = (token, ...args) => `${(0, exports.formatBigNumber)((0, exports.normalizeValue)(...args))} ${(token === null || token === void 0 ? void 0 : token.symbol) || ""}`.trim();
exports.formatAndNormalizeToken = formatAndNormalizeToken;
const formatShortNumber = (value = 0) => {
    const [integer] = value.toString().split(".");
    const format = SHORT_NUMBERS.find((current, index, array) => current.decimals < integer.length &&
        ((array[index + 1] && array[index + 1].decimals >= integer.length) || !array[index + 1]));
    return format ? integer.slice(0, integer.length - format.decimals) + format.symbol : integer;
};
exports.formatShortNumber = formatShortNumber;
